/** 地址ID多值检索的最大数量，与后端 MAX_COOPERATION_WAREHOUSE_IDS 保持一致 */
export const MAX_ADDRESS_IDS = 50;

export interface ParseAddressIdsResult {
  ids: number[];
  error?: 'invalid' | 'tooMany';
}

/**
 * 解析「地址ID」多值输入：支持回车/逗号/空格分隔。
 * 过滤纯数字 token，去重并保持顺序。
 * - 空输入返回 { ids: [] }（不算错误，等于不按ID过滤）
 * - 含非纯数字 token 返回 error='invalid'
 * - 超过 MAX_ADDRESS_IDS 返回 error='tooMany'
 */
export function parseAddressIds(value: string | undefined): ParseAddressIdsResult {
  const text = (value ?? '').trim();
  if (!text) {
    return { ids: [] };
  }

  const tokens = text
    .split(/[\r\n,\s]+/)
    .map((t) => t.trim())
    .filter(Boolean);

  const seen = new Set<number>();
  const ids: number[] = [];
  for (const token of tokens) {
    if (!/^\d+$/.test(token)) {
      return { ids: [], error: 'invalid' };
    }
    const n = Number(token);
    if (!Number.isSafeInteger(n) || n <= 0) {
      return { ids: [], error: 'invalid' };
    }
    if (!seen.has(n)) {
      seen.add(n);
      ids.push(n);
    }
  }

  if (ids.length > MAX_ADDRESS_IDS) {
    return { ids: [], error: 'tooMany' };
  }

  return { ids };
}
